import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { SystemDrawerComponent } from '@arc/arc-configuration-frontend';
import { DemoDataService, PermissionTypes, getActiveTenant$ } from '@arc/arc-shared-frontend';
import { MenuItem } from '@arc/aureus';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-configuration-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('drawer', { static: true })
  drawer: SystemDrawerComponent;
  enableBpnSettings$: Observable<boolean>;
  editProfileMenuItems: MenuItem[];
  editProfileMenuItems$;
  menuPermissionString = [
    {
      id: 'btnSSOConfiguration',
      permissionString: this.permissionDefinition.SSOConfiguration + ':read'
    },
    {
      id: 'btnCreditCardProcessingConfiguration',
      permissionString: 'arc-payments-permission-cardmerchantaccountmanagement:read'
    },
    // {
    //   id: 'btnBankProcessingConfiguration',
    //   permissionString: 'arc-permission-section-payments-permission-bank-merchant-reg:read'
    // },
    {
      id: 'btnTableConfiguration',
      permissionString: ''
    },
    {
      id: 'btnTaggingConfiguration',
      permissionString: this.permissionDefinition.UserRoleManagement + ':edit'
    },
    {
      id: 'btnSenderDomainConfiguration',
      permissionString: 'arc-permission-section-email-sender-domain:read'
    }
  ];

  selectedMenu: MenuItem;
  ssoStatus$;
  allowDemoDataButton$ = getActiveTenant$(this.store).pipe(
    map(tenant => tenant.tenantType === 'automation' || tenant.tenantType === 'demo'));
  demoDataPreventDoubleClick = false;
  enableCreditSettingsButton$;
  private _isLive = true;

  constructor(
    private store: Store<any>,
    public permissionDefinition: PermissionTypes,
    private demoDataV1Service: DemoDataService,
    private router: Router,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.editProfileMenuItems = [
      {
        id: 'btnDataSourceConfiguration',
        icon: 'storage',
        label: 'Data Source',
        command: $event =>
          this.openSystemDrawer($event, 'btnDataSourceConfiguration')
      },
      {
        id: 'btnSSOConfiguration',
        icon: 'recent_actors',
        label: 'SSO',
        command: $event => this.openSystemDrawer($event, 'btnSSOConfiguration')
      },
      {
        id: 'btnCreditCardProcessingConfiguration',
        icon: 'credit_card',
        label: 'Card Processing',
        command: $event => this.openSystemDrawer($event, 'btnCreditCardProcessingConfiguration')
      },
      {
        id: 'btnTableConfiguration',
        icon: 'table_view',
        label: 'Table Configuration',
        command: $event => this.openSystemDrawer($event, 'btnTableConfiguration')
      },
      {
        id: 'btnTaggingConfiguration',
        icon: 'label',
        label: 'Tagging',
        command: $event => this.openSystemDrawer($event, 'btnTaggingConfiguration')
      },
      {
        id: 'btnSenderDomainConfiguration',
        icon: 'email',
        label: this.translateService.instant('ARC_CONFIGURATION_SENDER_DOMAIN_COMPONENTS_DRAWER_TITLE'),
        command: $event => this.openSystemDrawer($event, 'btnSenderDomainConfiguration')
      }
    ];
    this.selectedMenu = this.editProfileMenuItems[0];
    this.editProfileMenuItems$ = this.permissionDefinition.filterArrayWithPermission$(
      this.editProfileMenuItems
        .map(x => {
          const result = this.menuPermissionString.find(t => t.id === x.id);
          let y: any = x;
          if (result) {
            y = { ...x, permissionString: result.permissionString };
          }
          return y;
        })
        .filter(p => p.permissionString),
      'permissionString'
    );
    this.enableCreditSettingsButton$ = this.permissionDefinition.isPermitted$(
      'credit-app-permission-section-credit-settings-permission-credit-configurations' +
        ':edit'
    );

    this.enableBpnSettings$ = this.permissionDefinition.isPermitted$(
      'bpn-app-section-supplier-permission-upload-portal-credentials:edit||' +
      'bpn-app-section-supplier-permission-upload-credit-cards:edit||' +
      'bpn-app-section-supplier-permission-manage-payment-preferences:edit||' +
      'bpn-app-section-supplier-permission-manage-remittance-settings:edit||' +
      'bpn-app-section-supplier-permission-manage-company-profile:edit'
       );
  }

  ngAfterViewInit() {
    // TODO: remove after dev
    // this.openSystemDrawer(null, 'btnSSOConfiguration');
  }

  ngOnDestroy(): void {
    this._isLive = false;
  }

  canceled($event) {
    // this.drawer.visibleChange(false);
  }

  havePermissionToDo(permissionString, fn: Function) {
    this.permissionDefinition
      .isPermitted$(permissionString)
      .subscribe(result => {
        if (result) {
          fn = fn.bind(this);
          fn();
        }
      });
  }
  openSystemDrawer(event: MouseEvent, selectedSectionId: string) {
    this.drawer.activeSection = this.drawer.settingSections.find(
      section => section.id === selectedSectionId
    );
    this.drawer.open(event);
  }

  refreshDemoData($event) {
    this.demoDataPreventDoubleClick = true;
    this.demoDataV1Service.putDemoDataRequest$().subscribe(() => {
      setTimeout(() => (this.demoDataPreventDoubleClick = false), 30000);
      //this.store.dispatch()
    });
  }

}
